import { Component, OnInit, ViewChildren, QueryList, ViewChild, HostListener } from '@angular/core';
import { FormBuilder, Validators, FormGroup, NgForm } from '@angular/forms';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { APIObserverService } from '../../_observerServices/API-Observer';
import { DataSource } from '@angular/cdk/table';
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { Constants } from '../../../../_utils/Constants';
//import { APIComplaintsService } from '../../_services/complaints/API-complaints';
import { formatDate } from '@angular/common';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { map } from 'rxjs/operators';
import { saveAs as importedSaveAs } from "file-saver";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';


const now = new Date();
const time_today = now.getTime();
const formatTime = formatDate(time_today, 'HH:mm', 'en-US', '+0530');
const currentdat = formatDate(now, 'dd-MM-yyyy', 'en-US', '+0530');
console.log("formatTime -- : ", formatTime);

const CACHE_KEY = 'httpRepoChache';

@Component({
  selector: 'app-complaints-obv-dashboard-oap',
  templateUrl: './complaints-obv-dashboard-oap.component.html',
  styleUrls: ['./complaints-obv-dashboard-oap.component.css']
})
export class ComplaintsObvDashboardOapComponent implements OnInit {
  maxDate: Date = new Date();
  filterData: any;
  dataSource: MatTableDataSource<any>;
  noRecord: any;

  floredvalue: number;
  counts: any;
  selectStatus: boolean = false;
  selectResolutionCode: boolean = false;
  selectCMPhandle: boolean = false
  selectResolutionStatus: boolean = false

  @ViewChild(MatPaginator) paginator: MatPaginator;

  // @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();  
  @ViewChild('tSort') sort: MatSort;
  //  @ViewChild(MatSort) sort: MatSort;


  form1: any = {};

  dataSubject = new BehaviorSubject<any[]>([]);

  // //table columns
  // displayedColumns: string[] = ['AIRTEL', 'BSNL', 'IDEA', 'JIO', 'MTNL', 'QTL', 'TATA', 'VMIPL', 'VODAFONE', 'TOTAL COMPLAINTS'];

  displayedColumns: string[] = ['TAP', 'open', 'valid', 'invalid', 'reports', 'rejectedbytap', 'total']
  fetchedData: any;
  data: any = {};
  constructor(
    private obv: APIObserverService,
    private db: $DBManagerService,
    private fb: FormBuilder,
    private $modal: $ModalManagerService,

    //private imp: APIComplaintsService,



  ) { }

  ngOnInit() {
    this.APIgetComplaintSummary();
  }
  onChangeDataSource(value) {
    this.dataSubject.next(value);
    this.dataSource = new MatTableDataSource();

    this.dataSource = new MatTableDataSource(value);
    // this.dataSource.paginator = this.paginator.toArray()[0];
    //  this.noRecord = this.dataSource.connect().pipe(map(data => data.length === 0));
    // this.noRecord = this.dataSource.connect().pipe(map(data => data.length === 0));

    console.log("dataSource : ", this.dataSource);
  }
  APIgetComplaintSummary() {
    var data = {
      'bookMark': "",
      'size': "10",
      'filterBy': "",
      'data' : "",
    }
    this.obv.complaintsObserverDataCount(this.data)
      .subscribe(r => {
        // this.bookmark = r.bookmark
        // this.counts = r.count
        // this.floredvalue = Math.ceil(this.counts / 10)
        
        //r = { 'tap':"VI", 'open':"123",'valid':"22",'invalid':"23",'reports':"233",'rejectedbytap':"2333",'total':'3432' };
        this.dataSource = r.value;
        this.onChangeDataSource(r.value);
      });
    // ['TAP', 'open', 'valid', 'invalid', 'reports', 'rejectedbytap', 'total']
 
    //     this.onChangeDataSource(r);



    // this.imp.getComplaintsReport(status).subscribe({

    //   next: value => {
    //     this.dataSubject.next(value);  
    //     this.dataSource = new MatTableDataSource();

    //     this.dataSource = new MatTableDataSource(value);
    //     this.dataSource.paginator = this.paginator;
    //     this.dataSource.sort = this.sort;
    //     console.log("dataSource : ", this.dataSource);
    //   }
    // });
  }

  enddateError = false
  addEvent(event: MatDatepickerInputEvent<Date>) {
    if (event.value) {
      this.enddateError = false;
    }
  }
  addEventEnddate(event: MatDatepickerInputEvent<Date>) {
    if (event.value) {
      this.enddateError = true;
    }
  }



  downloadreportcsvfile() {

    var fileName;
    const currentdat = formatDate(now, 'medium', 'en-US', '+0530');
    // this.imp.downloadComplaintsReportFile(this.data).subscribe(r => {  
    //   fileName = currentdat + ' Complaint Reports.csv';
    //   importedSaveAs(r, fileName)
    //   //  this.downloadFile(r, Batch_Id);
    //   this.$modal.successModal({
    //     title: 'Complaint Reports',
    //     msg: 'File has been downloaded Successfully'
    //   });
    // })

  }

  // getSubstring(newfilename) {
  //   if (newfilename)
  //     return newfilename.substring(newfilename.indexOf('.') + 1)
  //   else
  //     return
  //   }

  download(dcmp, filename) {
    var data = {
      URN: dcmp,
      blobFileName: dcmp + "/TMEvidenceDocuments/0/" + filename,
      downloadFileName: filename,
      storageName: "complaints"
    }
    //console.log("dataaaa", data)

    // this.imp.filedownload(data).subscribe(r => {

    //   this.downloadFile(r, this.getSubstring(filename));
    //   this.$modal.successModal({
    //     title: 'Complaint Reports Summary ',
    //     msg: 'File has been downloaded Successfully'
    //   });
    // })
  }

  private downloadFile(res: any, filename: string): void {
    const url = window.URL.createObjectURL(res);
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.setAttribute('style', 'display: none');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }

}
